import { createSlice } from "@reduxjs/toolkit";

import {
    getLandingPageDetailVisitsAsync,
    getLandingPageReportsAsync,
    getLandingPageVisitsAsync,
} from "./landingReports.asyncActions";
import { initialState } from "./landingReports.types";

export const landingPageReportsReducer = "landingPageReports";

export const landingPageReportsSlice = createSlice({
    name: landingPageReportsReducer,
    initialState,
    reducers: {
        clearLandingPageReports: (state) => {
            state.landingPageReports = null;
            state.landingPageVisits = null;
            state.landingPageDetailVisits = null;
            return state;
        },
    },
    extraReducers: (builder) => {
        // CHART
        builder
            .addCase(getLandingPageReportsAsync.pending, (state) => {
                state.isReportsLoading = true;
            })
            .addCase(getLandingPageReportsAsync.fulfilled, (state, action) => {
                state.isReportsLoading = false;
                state.landingPageReports = action.payload;
            })
            .addCase(getLandingPageReportsAsync.rejected, (state, action) => {
                state.isReportsLoading = false;
            });

        // VISITS
        builder
            .addCase(getLandingPageVisitsAsync.pending, (state) => {
                state.isVisitsLoading = true;
            })
            .addCase(getLandingPageVisitsAsync.fulfilled, (state, action) => {
                state.isVisitsLoading = false;
                state.landingPageVisits = action.payload;
            })
            .addCase(getLandingPageVisitsAsync.rejected, (state, action) => {
                state.isVisitsLoading = false;
            });

        // DETAIL
        builder
            .addCase(getLandingPageDetailVisitsAsync.pending, (state) => {
                state.isDetailLoading = true;
                state.landingPageDetailVisits = null;
            })
            .addCase(
                getLandingPageDetailVisitsAsync.fulfilled,
                (state, action) => {
                    state.isDetailLoading = false;
                    state.landingPageDetailVisits = action.payload;
                },
            )
            .addCase(getLandingPageDetailVisitsAsync.rejected, (state) => {
                state.isDetailLoading = false;
            });
    },
});

export default landingPageReportsSlice.reducer;
export const { clearLandingPageReports } = landingPageReportsSlice.actions;
